import Box from '@mui/material/Box';
import type { SxProps, Theme, TypographyVariant } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

import { mergeSx } from '@/utils/mergeSx';

import { separatedStyles as sx } from './Separated.styles';

type Layout = 'wrap' | 'cut';

type Props = {
	left?: ReactNode;
	right?: ReactNode;
	layout?: Layout;
	separator?: string;
	variant?: TypographyVariant;
	customSx?: {
		separator?: SxProps<Theme>;
	};
};

export const Separated = ({
	left,
	right,
	layout,
	separator = '•',
	variant = 'body2',
	customSx
}: Props) => {
	const hasBoth = left != null && right != null;

	const separatorNode = hasBoth ? (
		<Box component='span' sx={mergeSx(sx.separator, customSx?.separator)}>
			{separator}
		</Box>
	) : null;

	return (
		<Typography
			component='div'
			variant={variant}
			sx={layout === 'cut' ? sx.cutRow : undefined}
		>
			{left}
			{separatorNode}
			{right}
		</Typography>
	);
};
